import { optionSubcategory_smime } from './smimeSubCategory.locstring.json';
import { SmimeOption } from 'owa-smime-option';
import { OptionSubCategory } from 'owa-options-core';
import { lazySmimeAdapter } from 'owa-smime-adapter';
import { trace } from 'owa-trace';

let smimeSubCategory: OptionSubCategory = {
    key: 'smime',
    titleStringKey: optionSubcategory_smime,
    options: [SmimeOption],
    onSelected: () => loadSmimeControl(),
};

async function loadSmimeControl(): Promise<boolean> {
    try {
        await lazySmimeAdapter.import();
        return true;
    } catch (e) {
        trace.error('SmimeTraceError: Unable to load S/MIME control in settings');
        return false;
    }
}

export default smimeSubCategory;
